// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2Qa0R","footer":"ReportModalFilter_footer__3GlhJ"};